import Vue from 'vue'
import Router from 'vue-router'
import VueRouter from "vue-router";
//import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this,location).catch(err => err)
}
const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location){
  return originalReplace.call(this , location).catch(err=>err)
}
export default new Router({
  //mode:'history',
  routes: [

    //================================== 登录
    {
      name: 'Login',
      path: '/login',
      component: () => import('../views/login/Login'),
      meta: {
        title: '登录',
        requireLogin: false
      }
    },
    {
      name: 'Reg',
      path: '/reg',
      component: () => import('../views/login/Reg'),
      meta: {
        title: '注册',
        requireLogin: false
      }
    },
    {
      path: '/sso',
      component: () => import('../views/login/Sso'),
      meta: {
        title: '',//SSO
      }
    },
    //================================== 首页
    {
      name: 'Index',
      path: '/',
      component: () => import('../views/index/Index'),
      meta: {
        title: '首页',
        requireLogin: false,
      }
    },
    {
      name: 'NewIndex',
      path: '/new_index',
      component: () => import('../views/index/NewIndex'),
      meta: {
        title: '首页',//临时公告首页
        requireLogin: false,
      }
    },
    {
      name: 'IndexPreview',
      path: '/index_preview',
      component: () => import('../views/index/IndexPreview'),
      meta: {
        title: '首页预览',
        requireLogin: false,
      }
    },
    {
      name: 'Test',
      path: '/test',
      component: () => import('../views/index/test'),
      meta: {
        title: 'test',
        requireLogin: false,
      }
    },
    {
      name: 'Search',
      path: '/search',
      component: () => import('../views/index/Search'),
      meta: {
        title: '搜索',
        requireLogin: false,
      }
    },
    {
      name: 'PickupCoupon',
      path: '/pickupcoupon',
      component: () => import('../views/index/PickupCoupon'),
      meta: {
        title: '可领取优惠券',
        requireLogin: false,
      }
    },
    //================================== 自定义页面
    {
      name: 'Land',
      path: '/land/:id',
      component: () => import('../views/land/Land'),
      meta: {
        title: '',//自定义页面
        requireLogin: false,
      }
    },
    {
      name: 'LandPreview',
      path: '/landpreview',
      component: () => import('../views/land/LandPreview'),
      meta: {
        title: '预览自定义页面',
        requireLogin: false,
      }
    },
    //================================== 购物车
    {
      name: 'Cart',
      path: '/cart',
      component: () => import('../views/cart/Cart'),
      meta: {
        title: '购物车',
        requireLogin: true,
      }
    },
    //================================== 商品筛选
    {
      name: 'GoodsCategory',
      path: '/goodscategory',
      component: () => import('../views/goods/GoodsCategory'),
      meta: {
        title: '商品分类',
        requireLogin: false,
        keepAlive: true
      }
    },
    {
      name: 'GoodsList',
      path: '/goodslist',
      component: () => import('../views/goods/GoodsList'),
      meta: {
        title: '商品列表',
        requireLogin: false,
        keepAlive: true
      }
    },
    //================================== 商品详情
    {
      name: 'GoodsReviewList',
      path: '/goodsreviewlist',
      component: () => import('../views/goods/GoodsReviewList'),
      meta: {
        title: '商品评价列表',
        requireLogin: false,
        //keepAlive: true
      }
    },
    {
      name: 'GoodsView',
      path: '/goods/:id',
      component: () => import('../views/goods/GoodsView'),
      meta: {
        title: '商品详情',
        requireLogin: false,
        //keepAlive: true
      }
    },
    {
      name: 'GoodsPreView',
      path: '/pre_goods/:id',
      component: () => import('../views/goods/GoodsPreView'),
      meta: {
        title: '商品详情',
        requireLogin: false,
        //keepAlive: true
      }
    },
    {
      name: 'GoodsViewPickupCoupon',
      path: '/goods_pickupcoupon',
      component: () => import('../views/goods/GoodsViewPickupCoupon'),
      meta: {
        title: '可领取优惠券',
        requireLogin: false,
      }
    },
    //================================== 下单、订单
    {
      name: 'Order',
      path: '/order',
      component: () => import('../views/order/Order'),
      meta: {
        title: '订单详情',
        requireLogin: true,
        //keepAlive: true
      }
    },
    {
      name: 'OrderSubmit',
      path: '/ordersubmit',
      component: () => import('../views/order/OrderSubmit'),
      meta: {
        title: '确认订单',
        requireLogin: true,
        //keepAlive: true
      }
    },
    {
      name: 'OrderExpress',
      path: '/orderexpress',
      component: () => import('../views/order/OrderExpress'),
      meta: {
        title: '物流信息',
        requireLogin: true,
        //keepAlive: true
      }
    },
    {
      name: 'Pay',
      path: '/pay',
      component: () => import('../views/pay/Pay'),
      meta: {
        title: '支付',
        requireLogin: true,
        //keepAlive: true
      }
    },
    //================================== 退货
    {
      name: 'RefundSubmit',
      path: '/refundsubmit',
      component: () => import('../views/refund/RefundSubmit'),
      meta: {
        title: '申请退款',
        requireLogin: true,
        //keepAlive: true
      }
    },
    {
      name: 'RefundView',
      path: '/refund',
      component: () => import('../views/refund/RefundView'),
      meta: {
        title: '退款详情',
        requireLogin: true,
        //keepAlive: true
      }
    },
    //================================== 提交评价
    {
      name: 'ReviewSubmit',
      path: '/reviewsubmit',
      component: () => import('../views/review/ReviewSubmit'),
      meta: {
        title: '提交评价',
        requireLogin: true,
        //keepAlive: true
      }
    },
    //================================== 门店列表（展示用）
    {
      name: 'StoreList',
      path: '/storelist',
      component: () => import('../views/store/StoreList'),
      meta: {
        title: '门店列表',
        requireLogin: false,
        //keepAlive: true
      }
    },
    {
      name: 'StoreView',
      path: '/store',
      component: () => import('../views/store/StoreView'),
      meta: {
        title: '门店详情',
        requireLogin: false,
        //keepAlive: true
      }
    },
    //================================== 我的个人中心
    {
      name: 'Me',
      path: '/me',
      component: () => import('../views/me/Me'),
      meta: {
        title: '我',
        requireLogin: true,
        //keepAlive: true
      }
    },
    {
      name: 'MyFav',
      path: '/myfav',
      component: () => import('../views/me/MyFav'),
      meta: {
        title: '我的收藏',
        requireLogin: true,
        //keepAlive: true
      }
    },
    {
      name: 'MyStore',
      path: '/mystore',
      component: () => import('../views/me/MyStore'),
      meta: {
        title: '我的服务门店',
        requireLogin: true,
        //keepAlive: true
      }
    },
    {
      name: 'MyFootprint',
      path: '/myfootprint',
      component: () => import('../views/me/MyFootprint'),
      meta: {
        title: '我的足迹',
        requireLogin: true,
        //keepAlive: true
      }
    },
    {
      name: 'MySaler',
      path: '/mysaler',
      component: () => import('../views/me/MySaler'),
      meta: {
        title: '我的专属导购',
        requireLogin: true,
        //keepAlive: true
      }
    },
    {
      name: 'MyAddress',
      path: '/myaddress',
      component: () => import('../views/me/MyAddress'),
      meta: {
        title: '我的收货地址',
        requireLogin: true,
        keepAlive: false
      }
    },
    // {
    //   name: 'AddressEdit',
    //   path: '/addressedit',
    //   component: () => import('../views/me/AddressEdit'),
    //   meta: {
    //     title: '编辑收货地址',
    //     requireLogin: true,
    //     keepAlive: true
    //   }
    // },
    // {
    //   name: 'AddressChioc',
    //   path: '/addresschioc',
    //   component: () => import('../components/AddressChioc'),
    //   meta: {
    //     title: '提交订单选择收货地址',
    //     requireLogin: true,
    //     keepAlive: true
    //   }
    // },
    {
      name: 'MyProfile',
      path: '/myprofile',
      component: () => import('../views/me/MyProfile'),
      meta: {
        title: '我的个人信息',
        requireLogin: true,
        //keepAlive: true
      }
    },
    {
      name: 'MySetting',
      path: '/setting',
      component: () => import('../views/me/MySetting'),
      meta: {
        title: '设置',
        requireLogin: true,
        //keepAlive: true
      }
    },
    //================================== 我的订单等
    {
      name: 'MyOrder',
      path: '/myorder',
      component: () => import('../views/me/MyOrder'),
      meta: {
        title: '我的订单',
        requireLogin: true,
        keepAlive: true
      }
    },
    {
      name: 'MyRefund',
      path: '/myrefund',
      component: () => import('../views/me/MyRefund'),
      meta: {
        title: '我的退款',
        requireLogin: true,
        keepAlive: true
      }
    },
    //================================== 我的资产
    {
      name: 'MyCoin',
      path: '/mycoin',
      component: () => import('../views/me/MyCoin'),
      meta: {
        title: '我的金币',
        requireLogin: true,
        //keepAlive: true
      }
    },
    {
      name: 'MyCoupon',
      path: '/mycoupon',
      component: () => import('../views/me/MyCoupon'),
      meta: {
        title: '我的优惠券',
        requireLogin: true,
        //keepAlive: true
      }
    },
    {
      name: 'MyRedpacket',
      path: '/myredpacket',
      component: () => import('../views/me/MyRedpacket'),
      meta: {
        title: '我的红包',
        requireLogin: true,
        //keepAlive: true
      }
		},
		{
      name: 'MyPointExpireNow',
      path: '/mypointexpirenow',
      component: () => import('../views/me/MyPointExpireNow'),
      meta: {
        title: '即将过期积分',
        requireLogin: true,
        //keepAlive: true
      }
		},
		{
      name: 'MyPoint',
      path: '/mypoint',
      component: () => import('../views/me/MyPoint'),
      meta: {
        title: '我的积分明细',
        requireLogin: true,
        //keepAlive: true
      }
    },
    {
      name: 'MyPrize',
      path: '/myprize',
      component: () => import('../views/me/MyPrize'),
      meta: {
        title: '中奖记录',
        requireLogin: true,
        //keepAlive: true
      }
    },
    {
      name: 'MyDrawDetail',
      path: '/mydrawdetail',
      component: () => import('../views/me/MyDrawDetail'),
      meta: {
        title: '抽奖',
        requireLogin: true,
        //keepAlive: true
      }
    },
    {
      name: 'MyExemptionClause',
      path: '/myexemptionclause',
      component: () => import('../views/me/MyExemptionClause'),
      meta: {
        title: '免责条款',
        requireLogin: true,
        //keepAlive: true
      }
    },
    {
      name: 'MyAbout',
      path: '/myabout',
      component: () => import('../views/me/MyAbout'),
      meta: {
        title: '关于',
        requireLogin: true,
        //keepAlive: true
      }
    },
    //================================== 促销
    {
      name: 'Fullreduction',
      path: '/fullreduction',
      component: () => import('../views/promotion/Fullreduction'),
      meta: {
        title: '满减促销',
        requireLogin: true,
        //keepAlive: true
      }
    },
    {
      name: 'Combobuy',
      path: '/combobuy',
      component: () => import('../views/promotion/Combobuy'),
      meta: {
        title: '搭配购',
        requireLogin: true,
        //keepAlive: true
      }
    },
    //================================== 推广
    {
      name: 'IndexSpread',
      path: '/SpreadIndex',
      component: () => import('../views/spread/SpreadIndex'),
      meta: {
        title: '',
        requireLogin: true,
        //keepAlive: true
      }
    },
    {
      name: 'StoreSpread',
      path: '/Storespread',
      component: () => import('../views/spread/StoreSpread'),
      meta: {
        title: '门店推广',
        requireLogin: true,
        //keepAlive: true
      }
    },
    {
      name: 'GoodsSpread',
      path: '/Goodsspread',
      component: () => import('../views/spread/GoodsSpread'),
      meta: {
        title: '商品推广',
        requireLogin: true,
        //keepAlive: true
      }
    },
    {
      name: 'LuckyDraw',
      path: '/Luckydraw',
      component: () => import('../views/spread/LuckyDraw'),
      meta: {
        title: '抽奖活动',
        requireLogin: true,
        //keepAlive: true
      }
    },
    {
      name: 'SmallPrint',
      path: '/smallPrint',
      component: () => import('../views/smallPrint/smallPrintPreview'),
      meta: {
        title: '小票预览',
        requireLogin: true
      }
    },
    //================================== 其他
    {
      path: '*',
      redirect: '/'
    },












  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      if( to.hash ){
        return {
          selector: to.hash
        }
      } else {
        return {
          x: 0,
          y: 0
        }
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js